import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { LayoutComponent } from '../navigation/layout/layout.component';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { LoginGuard } from '../security/login.guard';
import { ShipmentPageComponent } from '../shipment/shipment-page/shipment-page.component';
import { ShipmentsPageComponent } from '../shipment/shipments-page/shipments-page.component';
import { ShipmentPreparationComponent } from '../shipment/shipment-preparation/shipment-preparation.component';
import { AddressBooksPageComponent } from '../address-books/address-books-page/address-books-page.component';
import { ContactsPageComponent } from '../address-books/contacts-page/contacts-page.component';
import { HeaderElementsEnum } from '../../enum/header-elements.enum';
import { InvoicesPageComponent } from '../invoices/invoices-page/invoices-page.component';
import { PickupPageComponent } from '../pickup/pickup-page/pickup-page.component';
import { SettingsPageComponent } from '../settings/settings-page/settings-page.component';
import { BatchPageComponent } from '../shipment/batch-page/batch-page.component';
import { AddressesPageComponent } from '../address-books/addresses-page/addresses-page.component';
import { EntityEnum } from '../../enum/entity.enum';
import { inject } from '@angular/core';
import { PackageLibraryPageComponent } from '../package-library/package-library-page/package-library-page.component';
import { PackagesPageComponent } from '../package-library/packages-page/packages-page.component';
import { CommoditiesPageComponent } from '../package-library/commodities-page/commodities-page.component';
import { ShipmentViewComponent } from '../shipment/shipment-view/shipment-view.component';
import { ShipmentQuotingComponent } from '../shipment/shipment-quoting/shipment-quoting.component';
import { ShipmentEditorComponent } from '../shipment/shipment-editor/shipment-editor.component';
import { ShipmentService } from '../../data/shipment.service';

export const routing: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [ (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(LoginGuard).canActivate(next, state) ],
        children:
            [
                { path: 'dashboard', component: DashboardComponent, data: {} },
                {
                    path: 'shipments',
                    component: ShipmentsPageComponent,
                    data: { title: $localize`Shipments`, createEntity: EntityEnum.SHIPMENT }
                },
                {
                    path: 'batch/:id/shipments',
                    component: ShipmentsPageComponent,
                    data: { title: $localize`Shipments`, createEntity: EntityEnum.SHIPMENT }
                },
                {
                    path: 'shipment/:id',
                    resolve: { shipment: ShipmentService },
                    component: ShipmentPageComponent,
                    data: { createEntity: EntityEnum.SHIPMENT, title: '%', shipmentEditor: true },
                    children: [
                        {
                            path: 'edit',
                            component: ShipmentEditorComponent,
                            data: { view: 'editor', toolbar: 'shipment' }
                        },
                        {
                            path: 'view',
                            component: ShipmentViewComponent,
                            data: { view: 'viewer', toolbar: 'shipment' }
                        },
                        {
                            path: 'quotes',
                            component: ShipmentQuotingComponent,
                            data: { view: 'quotes', toolbar: 'shipment' }
                        }
                    ]
                },
                {
                    path: 'shipment-edit/:id',
                    component: ShipmentPreparationComponent,
                    data: { createEntity: EntityEnum.SHIPMENT, title: '%', shipmentEditor: true }
                },
                {
                    path: 'addressbooks',
                    component: AddressBooksPageComponent,
                    data: { title: $localize`Address Books` }
                },
                {
                    path: 'addressbook/:id/contacts',
                    component: ContactsPageComponent,
                    data: { title: $localize`Contacts`, icon: 'address-card' }
                },
                {
                    path: 'contacts',
                    component: ContactsPageComponent,
                    data: { title: $localize`Contacts`, header: [ HeaderElementsEnum.CREATE_CONTACT ] }
                },
                {
                    path: 'addresses',
                    component: AddressesPageComponent,
                    data: { title: $localize`Addresses` },
                    children: [
                        {
                            path: 'contacts',
                            component: ContactsPageComponent,
                            data: { createEntity: EntityEnum.CONTACT }
                        },
                        {
                            path: ':id/contacts',
                            component: ContactsPageComponent,
                            data: { createEntity: EntityEnum.CONTACT }
                        },
                        {
                            path: 'books',
                            component: AddressBooksPageComponent,
                            data: { createEntity: EntityEnum.ADDRESS_BOOK }
                        },
                        {
                            path: '**',
                            redirectTo: 'contacts'
                        }
                    ]
                },
                {
                    path: 'library',
                    component: PackageLibraryPageComponent,
                    data: { title: $localize`Package Library` },
                    children: [
                        {
                            path: 'packages',
                            component: PackagesPageComponent
                        },
                        {
                            path: 'commodities',
                            component: CommoditiesPageComponent
                        },
                        {
                            path: '**',
                            redirectTo: 'packages'
                        }
                    ]
                },
                { path: 'invoices', component: InvoicesPageComponent, data: { title: $localize`Invoices` } },
                { path: 'pickups', component: PickupPageComponent, data: { title: $localize`Pickups` } },
                { path: 'batches', component: BatchPageComponent, data: { title: $localize`Batches` } },
                { path: 'settings', component: SettingsPageComponent, data: { title: $localize`Settings` } },
                { path: '**', redirectTo: 'shipments' }
            ]
    },
    { path: '**', redirectTo: '/dashboard' }
];
